import { render, staticRenderFns } from "./QuestionSelectionRoute.vue?vue&type=template&id=db198870&scoped=true&"
import script from "./QuestionSelectionRoute.vue?vue&type=script&lang=js&"
export * from "./QuestionSelectionRoute.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelectionRoute.vue?vue&type=style&index=0&id=db198870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db198870",
  null
  
)

export default component.exports